module.exports = __webpack_public_path__ + "packs/media/images/home_image-e5524a083b8fb3815c11a846ea290a29.png";